import { UI_SIZE } from '@constants/ui';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import type { SxProps, Theme } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLogoutMutation } from '@store/api/authEndpoints';
import { useAppSelector } from '@store/hooks';
import MenuContent from '../Menu/MenuContent';

interface CompactSideBarProps {
  open: boolean;
  toggleDrawer: () => void;
}

const CompactSideBar = ({ open, toggleDrawer }: CompactSideBarProps) => {
  const [logout] = useLogoutMutation();
  const authState = useAppSelector((state) => state.auth);
  const user = authState.user;

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Drawer anchor="right" open={open} onClose={toggleDrawer} sx={drawerStyles}>
      <Stack sx={outerStackStyles}>
        <Stack direction="row" sx={headerStackStyles}>
          <Stack direction="row" sx={profileStackStyles}>
            <Avatar
              sizes="small"
              alt={user?.name}
              sx={avatarStyles}
            />
            <Typography component="p" variant="h6">
              {user?.name}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={menuContentStackStyles}>
          <MenuContent toggleDrawer={toggleDrawer} />
          <Divider />
        </Stack>
        <Stack sx={logoutButtonStyles}>
          <Button
            onClick={handleLogout}
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

const drawerStyles: SxProps<Theme> = {
  width: UI_SIZE.DRAWER_WIDTH,
  [`& .${drawerClasses.paper}`]: {
    backgroundImage: 'none',
    backgroundColor: 'background.paper',
  },
};

const outerStackStyles: SxProps<Theme> = {
  width: UI_SIZE.DRAWER_WIDTH,
  height: '100%',
};

const headerStackStyles: SxProps<Theme> = {
  padding: 2,
  paddingBottom: 0,
  gap: 1,
};

const profileStackStyles: SxProps<Theme> = {
  gap: 1,
  alignItems: 'center',
  flexGrow: 1,
  padding: 1,
};

const avatarStyles: SxProps<Theme> = {
  width: 24,
  height: 24,
};

const menuContentStackStyles: SxProps<Theme> = {
  flexGrow: 1,
};

const logoutButtonStyles: SxProps<Theme> = {
  padding: 2,
};

export default CompactSideBar;
